import React, { useEffect, useRef, useState } from "react";
import Webcam from "react-webcam";
import { Button, Fab, Tooltip } from "@mui/material";
import { PreferredCameraType, getCameras } from "./SelectCamera";
import { IconWebcam, IconPhoto, IllustrationIdentity } from "TemplateCerere";
import { Delete, Close, ScreenRotation, FlipCameraIosOutlined, } from "@mui/icons-material";
import { base64ToArrayBuffer, guid } from "Utils";
import { DropZoneArea } from "TemplateCerere";
import "../index.css";
import "./ImageDocument.scss";


function ImageDocumentEc(props) {
  const { doc, actions, isMobile } = props;
  const webcamRef = useRef(null);
  const imageCropRef = useRef(null);
  const [photos, setPhotos] = useState([]); // Array pentru stocarea fotografiilor
  const [photoCount, setPhotoCount] = useState(1); // Numărul de fotografii

  //const [currentPhotoIndex, setCurrentPhotoIndex] = useState(null);
  const [hasCamera, setHasCamera] = useState(false); //este camera
  const [openPicture, setOpenPicture] = useState(false) //deschide camera
  //const [facingMode, setfacingMode]=useState("environment");
  //const [imageCss, setImageCss] = useState(null);
  const [imageSize, setImageSize] = useState(null);
  //const [resolution, setResolution] = useState(null);

  const [loading, setLoading] = useState(true);
  const [devices, setDevices] = useState([]);
  const [deviceIndex, setDeviceIndex] = useState(-1);
  const [maxFileSize, setMaxFileSize] = useState(5 * 1024 * 1024);
  const [errors, setErrors] = useState(doc.Jprop.errors || {});

  useEffect(() => {
    console.log("ImageDocument - componentDidMount");
    try {
      getCameras(PreferredCameraType.BackFacingCamera).then(
        (cameras) => {
          console.log("cameras", cameras);
          setDevices(cameras);
          //var hasCamera = cameras.length > 0;
          setHasCamera(cameras.length > 0);
          console.log("final cameras", cameras);
          //setDeviceIndex(0);
        }
      );
    } catch (e) {
      console.log("error getting camera", e);
    }
    var preferredDeviceIndex = -1;
    let tmp = doc?.Jprop?.template;
    //tmp.resolution = null;
    //tmp.resolution = tmp.resolution || { width: 1280, height: 900 };
    tmp.imageSize = tmp.imageSize || { width: 1280, height: 900 };
    //setImageCss(tmp.imageCss);
    //setResolution(tmp.resolution);
    setImageSize(tmp.imageSize);
    //setFacingMode(tmp.facingMode);
    setDeviceIndex(preferredDeviceIndex === -1 ? 0 : preferredDeviceIndex);
    setPhotoCount(tmp.photoCount || 1);
    setMaxFileSize((props.doc.Params.maxfilesize || 5 * 1024 * 1024) * 1);
    //setLoading(false);
  }, [doc.Jprop.template]);

  useEffect(() => {
    setLoading(true);
    getPhotos();
  }, [doc.DocFile]);

  const getPhotos = async () => {
    console.log("ImageDocument - getFile");
    var photoList = [];
    await doc.DocFile.forEach(item => {
      if (item.Id === null) return; // Skip items without Id
      photoList.push({ file: null, item: item });
      console.log("ImageDocument - getFile item", item);
    });

    await Promise.all(
      photoList.map(async (p, index) => {
        console.log("ImageDocument - getFile item", p.item);
        var file = await actions.showFile(p.item);
        console.log("ImageDocument - getFile file", p.item, "file");
        photoList[index].file = file;
      })
    );

    console.log("ImageDocument - getFile photoList", photoList);
    setPhotos(photoList);
    setLoading(false);

  };

  const takePhoto = async (info) => {
    let crop = {
      width: imageCropRef.current.clientWidth,
      height: imageCropRef.current.clientHeight,
    };
    var dataImage = webcamRef.current.getScreenshot();
    var image = new Image();
    image.width = webcamRef.current.canvas.width;
    image.height = webcamRef.current.canvas.height;
    //recalibrare crop in functie de rezolutie
    // rezolutia se preia din jprop din definitia fluxului si e definita pentru modul landscape
    if (
      webcamRef.current.canvas.width >
      webcamRef.current.video.clientWidth ||
      webcamRef.current.canvas.height >
      webcamRef.current.video.clientHeight
    ) {
      var rx =
        webcamRef.current.canvas.width /
        webcamRef.current.video.clientWidth;
      var ry =
        webcamRef.current.canvas.height /
        webcamRef.current.video.clientHeight;

      crop.width = crop.width * (rx > ry ? rx : ry);
      crop.height = crop.height * (rx > ry ? rx : ry);
    }

    image.src = dataImage;
    image.onload = async () => {
      const canvas = document.createElement("canvas");
      canvas.width = imageSize.width;
      canvas.height = imageSize.height;
      const ctx = canvas.getContext("2d");
      //calcul punct pornire pt crop
      var sx = (image.width - crop.width) / 2;
      var sy = (image.height - crop.height) / 2;
      ctx.drawImage(
        image,
        sx,
        sy,
        crop.width,
        crop.height,
        0,
        0,
        canvas.width,
        canvas.height
      );
      var dataUri = canvas.toDataURL("image/png");

      var indexEnd = dataUri.lastIndexOf("base64,");
      var contentFileData = dataUri.slice(indexEnd + 7);
      var typeFileData = dataUri
        .slice(0, indexEnd - 1)
        .replace("data:", "")
        .replace("image/", "");
      var contentFile = await base64ToArrayBuffer(contentFileData);
      var file = await new File([contentFile], `${guid()}.${typeFileData}`);

      setOpenPicture(false);
      setLoading(true);
      await actions.uploadFile(file, doc, info);
      setLoading(false);
    };
  };

  const removePhoto = async (item) => {
    setLoading(true);
    if (item.Info === "Fata") {
      photos.forEach((p) => { actions.deleteFile(p.item, doc); });
      setLoading(false);
      return;
    }
    setLoading(true);
    await actions.deleteFile(item, doc);
    setLoading(false);

  };

  const changeCamera = () => {
    /*
    const facingMode =
      this.state.facingMode == "environment" ? "user" : "environment";
    this.setState({
      facingMode: facingMode,
    });
    */
    if (devices && devices.length > 0) {
      var i = deviceIndex + 1;
      if (i >= devices.length) {
        i = 0;
      }
      setDeviceIndex(i);
    }
  };
  const getCamName = () => {
    console.log("ImageDocument - getCamName");
    if (devices && devices.length > 0) {
      return devices[deviceIndex].label;
    }
    return "No camera";
  };
  const handleError = (error) => {
    console.log(error);
    //const { actions } = this.props;
    //handleCloseCamera();
    setOpenPicture(false);
    if (
      error.toString().includes("Permission denied") ||
      error.toString().includes("not allowed")
    ) {
      actions.openError(
        "Eroare: browserul nu are drepturi pentru accesarea camerei!"
      );
      return;
    }
    var msg = error.message || error.name || error.toString();
    actions.openError(msg);
  };
  /* incarcare fisier cu drag&drop*/
  const handleUploadSave = async (files, info) => {
    var file = files[0];
    setLoading(true);
    await actions.uploadFile(file, doc, info);
  };

  return (
    <div className="e-card" id={`dco${doc.Id}`} key={doc.Id}>
      <div className="e-card-title">{doc.Jprop.title}</div>
      {doc.Jprop.subtitle && (
        <div className="e-card-subtitle">{doc.Jprop.subtitle}</div>
      )}
      {doc.Jprop.notice && (
        <div className="e-card-notice">{doc.Jprop.notice}</div>
      )}
      <div className="e-card-content-document image-wrapper">
        <div className="image-document">

          {photos.map((photo, index) => {
            return (
              <div key={index} >
                <h4>{photo.item.Info} </h4>

                <div className="image-document" >
                  <div className="image-back" >
                    <img
                      src={photo.file}
                      alt=""
                      className="image-preview"
                      onLoad={() => setLoading(false)}
                    />
                    <div className="image-btn-group note-camera ">
                    {doc.Incarcare && !doc.Stergere && photo.file && (
                      <Tooltip title="Sterge imaginea">
                        <Fab
                          size="medium"
                          color="secondary"
                          onClick={() => removePhoto(photo.item)}
                        >
                          <Delete />
                        </Fab>
                      </Tooltip>)}
                    </div>
                  </div>
                </div>

              </div>)
          })}

          {photos.length < photoCount && (
            <>
              <h4>{photoCount == 1 ? "Fata" : "Verso"} </h4>
              <div className={isMobile && openPicture ? "image-back-full-screen" : "image-back"}>

                {openPicture &&
                  <Webcam
                    className="web-cam"
                    audio={false}
                    ref={webcamRef}
                    screenshotFormat="image/png"
                    onUserMediaError={handleError}
                    videoConstraints={{ deviceId: devices[deviceIndex].deviceId }}
                  />}

                {!openPicture && <div className="image-preview-empty" />}
                {!openPicture && <IllustrationIdentity className="icon-id" />}
                {openPicture && !loading && (

                  <div className="image-btn-group">
                    {doc.Incarcare &&devices && devices.length > 0 && (
                      <div className="image-btn-close">
                        <Tooltip title="Schimba camera">
                          <Fab
                            onClick={changeCamera}
                            className="image-switch-btn"
                          >
                            <FlipCameraIosOutlined fontSize="large" />
                          </Fab>
                        </Tooltip>
                      </div>
                    )}

                    <div className="image-btn-close">
                      <Tooltip title="Fotografiaza">
                        <Fab
                          onClick={() => takePhoto(photoCount == 1 ? "Fata" : "Verso")}
                          className="image-photo"
                        >
                          <IconPhoto className="image-photo-icon" />
                        </Fab>
                      </Tooltip>
                    </div>
                    <div className="image-btn-close">
                      <Tooltip title="Renunta la fotografiere">
                        <Fab
                          onClick={() => setOpenPicture(false)}
                          className="image-switch-btn"
                        >
                          <Close fontSize="large" />
                        </Fab>
                      </Tooltip>
                    </div>
                  </div>
                )}
                {doc.Incarcare && !openPicture && !loading && (
                  <div className="image-btn-group note-camera">
                    {hasCamera && (
                      <div className="image-btn-note">Deschide camera</div>
                    )}
                    <div className="image-btn">
                      {hasCamera && (
                        <Tooltip
                          title="Fotografiaza cartea ta de identitate"
                          leaveDelay={100}
                        >
                          <Fab
                            size="medium"
                            onClick={() => setOpenPicture(true)}
                            //color="primary"
                            className="image-webcam"
                          >
                            <IconWebcam className="image-webcam-icon" />
                          </Fab>
                        </Tooltip>
                      )}
                    </div>
                  </div>
                )}
                {openPicture && !loading && (
                  <>
                    <div className="image-rotate">
                      Roteste telefonul
                      <ScreenRotation
                        style={{
                          height: "3em",
                          width: "3em",
                          paddingTop: "15px",
                        }}
                      />
                    </div>
                    <div ref={imageCropRef} className="image-crop">
                      <span>Incadreaza documentul in chenar</span>
                      <div>{getCamName()}</div>
                    </div>
                  </>
                )}
              </div>
              {doc.Incarcare &&!openPicture && !loading && (
                <DropZoneArea
                  acceptedFiles={doc?.Params?.ext ? doc.Params.ext.split(",") : []}
                  filesLimit={1}
                  maxFileSize={maxFileSize}
                  onDrop={(f) => handleUploadSave(f, photoCount == 1 ? "Fata" : "Verso")}
                  openError={actions.openError}
                  errors={errors}
                />
              )}
            </>
          )}

        </div>
        <div className="image-values">
          <ul>
            <li>
              Serie <span>{doc.Jprop.ocr.serie}</span>, numar{" "}
              <span>{doc.Jprop.ocr.numar}</span>
            </li>
            <li>
              CNP <span>{doc.Jprop.ocr.cnp}</span>
            </li>
            <li>
              Nume <span>{doc.Jprop.ocr.nume}</span> prenume{" "}
              <span>{doc.Jprop.ocr.prenume}</span>
            </li>
            <li>
              Nationalitate <span>{doc.Jprop.ocr.nationalitate}</span>
            </li>
            <li>
              Loc.nastere <span>{doc.Jprop.ocr.loc_nastere}</span>
            </li>
            <li>
              Adresa <span>{doc.Jprop.ocr.adresa1}</span>{" "}
              <span>{doc.Jprop.ocr.adresa2}</span>
            </li>
            <li>
              Emitent <span>{doc.Jprop.ocr.emitent}</span>
            </li>
            <li>
              Data <span>{doc.Jprop.ocr.data_emitere}</span> -{" "}
              <span>{doc.Jprop.ocr.data_expirare}</span>
            </li>
            <li>
              MRZ1 <span>{doc.Jprop.ocr.mrz1}</span>
            </li>
            <li>
              MRZ2 <span>{doc.Jprop.ocr.mrz2}</span>
            </li>
          </ul>
        </div>

      </div>
    </div>
  );
}

export default ImageDocumentEc;